import type { Field } from "@aws-amplify/data-schema/dist/esm/runtime/bridge-types";
import { inputTypeMappings } from "./inputTypeMappings";
import type { StringFieldType } from "./StringFieldType";

export function isEditableField(field: Field): boolean {
  return (
    !!(
      inputTypeMappings[field.type as StringFieldType] ||
      (field.type as { enum: string }).enum
    ) &&
    !field.isArray &&
    !field.isReadOnly
  );
}
